<template>
  <div
    class="small-card merch-card"
    :data-id="item.id"
  >
    <img
      :src="item.imageUrl"
      alt=""
    >
    <h3>
      <a
        :href="item.slug"
        :target="target"
        data-gtmcat="merchandise engagement"
        data-gtmaction="click"
        :data-gtmlabel="item.title | striphtml"
      >
        <span>{{ item.title | striphtml }}</span>
      </a>
    </h3>
  </div>
</template>

<script>
// import Vue from 'vue'
// import VueLazyload from 'vue-lazyload'
 
// Vue.use(VueLazyload)
// Vue.use(VueLazyload, {
//   preLoad: 1.3,
//   error: 'dist/error.png',
//   loading: 'dist/loading.gif',
//   attempt: 1
// })

export default {
  name: "Merchandise",
  components: {
    // eslint-disable-next-line
    // VueLazyload,
  },
  props: {
    item: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  data() {
    return {
      target: '_self'
    }
  },
  mounted: function() {
    if(this.item.linkTarget !== 'internal'){
      this.target = '_blank'
    }
  }
}
</script>

